import * as React from 'react';
import {RouteComponentProps, withRouter} from "react-router";
import Brand from "../../../model/brand/Brand";
import ButtonSecondary from "../../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";
import Toast from "../../helper/Toast";
import Organization from "../../../model/organization/Organization";
import {Option} from "ts-option";
import {Dispatch} from "redux";
import {setBrandAsDefault} from "../../../store/action/brand/brand";
import {connect} from "react-redux";
import DataGrid from "../../../hiberUiKit/src/organisms/DataGrid/DataGrid";
import CurrencyHelper from "../../../helper/CurrencyHelper";

interface ComponentProps {
	/**
	 * Brands.
	 */
	brands: Brand[];
	/**
	 * Organization data.
	 */
	organization: Option<Organization>;
	/**
	 * Row click callback
	 */
	onRowClick: (brand: Brand) => void;
}

interface DispatchProps {
	/**
	 * Set brand as default brand for organization
	 * @param {Brand} brand
	 */
	setBrandAsDefault(brand: Brand): void;
}

type Props = RouteComponentProps<any> & ComponentProps & DispatchProps

class BrandsTable extends React.Component<Props, {}> {
	render() {
		return (
			<DataGrid>
				<thead>
				<tr>
					<th>Id</th>
					<th>Name</th>
					<th>Labour Cost</th>
					<th>Max fee</th>
					<th>Website</th>
					<th>Actions</th>
				</tr>
				</thead>
				<tbody>
				{this.props.brands.map((brand, index) =>
					<tr key={index}
						onClick={() => this.props.onRowClick(brand)}
						style={{cursor: "pointer", height: "73px"}}
						className={this.isDefault(brand) ? "is-selected" : ""}>
						<td>{brand.id}</td>
						<td>{brand.name}</td>
						<td>{CurrencyHelper.penniesToPounds(brand.labourCost)}</td>
						<td>{CurrencyHelper.penniesToPounds(brand.maxFee)}</td>
						<td>{brand.domain.getOrElse("")}</td>
						<td>{this.renderPromoteAsDefaultButton(brand)}</td>
					</tr>)
				}
				</tbody>
			</DataGrid>
		);
	}

	/**
	 * Render 'Promote as default' button.
	 */
	renderPromoteAsDefaultButton(brand: Brand) {
		if (this.isDefault(brand)) return null;
		return (
			<ButtonSecondary label="Promote as default"
							 onClick={() => this.props.setBrandAsDefault(brand)}/>
		);
	}

	/**
	 * Indicates if given brand id is default brand id for current organization.
	 * @param {string} brand
	 * @returns {boolean}
	 */
	isDefault(brand: Brand) {
		return this.props.organization.flatMap(o => o.brandId).orNull == brand.id;
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		setBrandAsDefault: (brand: Brand) =>
			dispatch(setBrandAsDefault(brand,
				() => Toast.success("Default brand updated.", "Default brand update"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Default brand update"))
			)
	}
}

export default withRouter<ComponentProps>(connect(null, mapDispatchToProps)(BrandsTable));
